function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m6.2 7.8v24.3h16.5v-3.7h-12v-7.1h9.9v-3.7h-9.9v-6h11.2v-3.8z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m36.2 28.5c.3 0 .6 0 1 .1h1.7c3 0 5.2-.8 6.7-2.3s2.2-3.6 2.2-6.3c0-2.8-.7-4.9-2.1-6.4s-3.6-2.2-6.6-2.2c-1.3 0-2.2 0-2.8.1v17zm16.2-8.5c0 2.1-.3 3.9-1 5.5s-1.6 2.9-2.8 3.9-2.7 1.8-4.4 2.3-3.6.8-5.6.8c-1 0-2.1 0-3.3-.1s-2.4-.3-3.5-.5v-23.7c1.1-.3 2.3-.4 3.6-.5s2.4-.1 3.4-.1c2 0 3.9.2 5.6.7s3.1 1.2 4.3 2.2 2.1 2.3 2.8 3.9c.6 1.5.9 3.4.9 5.6"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m60.8 32.1v-24.3h15.6v3.8h-11.2v6h10v3.7h-10v7.1h12v3.7z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m103.7 32.1c-.8-1.3-1.7-2.8-2.7-4.3s-2-3.1-3.1-4.6c-1.1-1.6-2.1-3.1-3.2-4.5-1.1-1.5-2.1-2.8-3.1-4v17.4h-4.4v-24.3h3.6c.9 1 1.9 2.1 3 3.5s2.2 2.7 3.2 4.2c1.1 1.5 2.1 2.9 3.2 4.4 1 1.5 1.9 2.8 2.7 4.1v-16.2h4.4v24.3z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m135.7 7.8c.5.9 1.1 2 1.7 3.3s1.3 2.6 1.9 4.1c.7 1.4 1.3 2.9 2 4.3.6 1.5 1.2 2.8 1.8 4.1.5-1.2 1.1-2.6 1.8-4.1.6-1.5 1.3-2.9 1.9-4.3.7-1.4 1.3-2.8 1.9-4.1s1.2-2.4 1.7-3.3h4c.2 1.8.4 3.7.6 5.7s.4 4 .5 6.1c.2 2.1.3 4.2.4 6.3s.2 4.2.3 6.2h-4.4c-.1-2.8-.2-5.7-.3-8.7s-.3-5.9-.6-8.7c-.3.5-.6 1.2-.9 1.9-.4.7-.7 1.6-1.1 2.4-.4.9-.8 1.8-1.2 2.7s-.8 1.8-1.2 2.7-.7 1.7-1.1 2.5c-.3.8-.6 1.4-.8 1.9h-3.3c-.2-.5-.5-1.2-.8-2s-.7-1.6-1.1-2.5-.8-1.8-1.2-2.7-.8-1.8-1.2-2.7-.8-1.7-1.1-2.4c-.4-.8-.7-1.4-.9-1.9-.3 2.8-.5 5.7-.6 8.7s-.2 5.9-.3 8.7h-4.4c.1-2 .2-4.1.3-6.2.1-2.2.3-4.3.4-6.4.2-2.1.3-4.2.5-6.2s.4-3.8.6-5.5z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m166 7.8h4.4v24.3h-4.4z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m196.9 28.3v3.8h-15.4v-24.3h4.5v20.5z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m220.2 28.3v3.8h-15.3v-24.3h4.4v20.5z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m121.3 29.9c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7 1.2-2.7 2.7-2.7c1.5-.1 2.7 1.2 2.7 2.7"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m54 51.6c.8 0 1.4-.1 1.8-.4s.6-.7.6-1.2c0-.3-.1-.6-.2-.8s-.3-.4-.5-.6-.5-.3-.9-.5c-.3-.2-.7-.3-1.2-.4-.4-.2-.8-.3-1.2-.5s-.8-.4-1.1-.7-.5-.6-.7-1-.3-.8-.3-1.4c0-1.1.4-2 1.2-2.7.8-.6 1.8-1 3.2-1 .8 0 1.5.1 2.1.3s1.1.4 1.4.6l-.7 1.8c-.4-.2-.9-.4-1.3-.5-.5-.1-1-.2-1.5-.2-.6 0-1.1.1-1.4.4-.3.2-.5.6-.5 1.1 0 .3.1.5.2.7s.3.4.5.5c.2.2.5.3.7.4.3.1.6.3.9.4.6.2 1.1.4 1.6.7.5.2.9.5 1.2.8s.6.7.7 1.1c.2.4.2.9.2 1.5 0 1.1-.4 2-1.2 2.6s-2 .9-3.5.9c-.5 0-1 0-1.4-.1s-.8-.1-1.1-.2-.6-.2-.9-.3c-.2-.1-.4-.2-.6-.3l.7-1.8c.3.2.8.4 1.3.5.4.2 1.1.3 1.9.3"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m71.6 40.9v1.9h-3.8v6.9h-2.3v-6.9h-3.8v-1.9z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m85.2 43.3c-.3.6-.6 1.4-.9 2.3-.4.9-.7 1.9-1.1 3h4.1c-.4-1.1-.8-2.1-1.1-3-.4-1-.7-1.7-1-2.3m3.7 10c-.2-.5-.3-1-.5-1.5s-.4-1-.5-1.5h-5.3c-.2.5-.3 1-.5 1.5s-.3 1-.5 1.4h-2.4c.5-1.3.9-2.6 1.3-3.7s.8-2.2 1.2-3.2.8-2 1.2-2.9.8-1.8 1.2-2.7h2.2c.4.9.8 1.8 1.2 2.7s.8 1.9 1.2 2.9.8 2.1 1.2 3.2.9 2.4 1.3 3.7z"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m103 53.3c-.4-.7-.9-1.4-1.4-2.2s-1-1.6-1.6-2.4c-.5-.8-1.1-1.6-1.6-2.3-.6-.7-1.1-1.4-1.6-2v8.9h-2.2v-12.4h1.8c.5.5 1 1.1 1.5 1.8s1.1 1.4 1.7 2.1 1.1 1.5 1.6 2.2 1 1.4 1.4 2.1v-8.2h2.2v12.4z"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m112 51.4h.5s.5 0 .9 0c1.5 0 2.7-.4 3.4-1.2s1.1-1.8 1.1-3.2-.4-2.5-1.1-3.2c-.7-.8-1.9-1.1-3.4-1.1-.7 0-1.2 0-1.4.1zm8.3-4.3c0 1.1-.2 2-.5 2.8s-.8 1.5-1.4 2-1.4.9-2.2 1.2c-.9.3-1.8.4-2.9.4-.5 0-1.1 0-1.7-.1-.6 0-1.2-.1-1.8-.3v-12.1c.6-.1 1.2-.2 1.8-.3h1.7c1 0 2 .1 2.9.4.8.2 1.6.6 2.2 1.2.6.5 1.1 1.2 1.4 2 .3.7.5 1.7.5 2.8"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m128.1 42.7c-.5 0-.9 0-1.3 0v4h1c.6 0 1 0 1.5-.1.4-.1.8-.2 1-.3.3-.2.5-.4.6-.6.2-.3.2-.6.2-1s-.1-.7-.2-1-.3-.5-.6-.6-.6-.3-1-.3c-.3-.1-.7-.1-1.2-.1m-.1-2c1.8 0 3.2.3 4.1 1 1 .7 1.4 1.7 1.4 3 0 1.7-.8 2.8-2.5 3.4.2.3.5.6.8 1s.6.8.9 1.3.6.9.9 1.4.5 1 .7 1.4h-2.5c-.2-.4-.5-.9-.7-1.3-.3-.4-.5-.9-.8-1.3s-.5-.8-.8-1.2-.5-.7-.7-1c-.2 0-.3 0-.4 0h-.3-1.1v4.7h-2.3v-12.1c.6-.1 1.1-.2 1.8-.2.5-.1 1-.1 1.5-.1"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m137.8 53.3v-12.4h8v1.9h-5.7v3h5.1v1.9h-5.1v3.7h6.2v1.9z"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m158.1 42.3c.2.6.4 1.3.6 2s.4 1.4.7 2.1c.2.7.5 1.4.7 2.1s.4 1.3.7 1.9c.2-.6.4-1.3.5-2.1.2-.8.3-1.6.5-2.4s.3-1.7.5-2.5.3-1.7.5-2.5h2.3c-.4 2.2-.9 4.4-1.4 6.5s-1.1 4.1-1.7 6h-2.2c-.9-2.4-1.8-5.1-2.7-7.9-.5 1.5-.9 2.8-1.4 4.1s-.9 2.6-1.4 3.8h-2.1c-.6-1.9-1.2-3.9-1.7-6s-1-4.2-1.4-6.5h2.4c.1.8.3 1.6.4 2.5.2.8.3 1.7.5 2.5s.3 1.6.5 2.4.4 1.5.5 2.1c.2-.6.5-1.2.7-1.9s.5-1.4.7-2.1.4-1.4.7-2.1c.2-.7.4-1.4.6-2z"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m171.8 51.6c.8 0 1.4-.1 1.8-.4s.5-.7.5-1.2c0-.3-.1-.6-.2-.8s-.3-.4-.5-.6-.5-.3-.9-.5c-.3-.2-.7-.3-1.1-.4-.4-.2-.9-.3-1.3-.5s-.7-.4-1.1-.7c-.3-.3-.6-.6-.7-1-.2-.4-.3-.8-.3-1.4 0-1.1.4-2 1.2-2.7.8-.6 1.8-1 3.2-1 .8 0 1.5.1 2.1.3s1.1.4 1.4.6l-.7 1.8c-.4-.2-.8-.4-1.3-.5s-1-.2-1.5-.2c-.6 0-1.1.1-1.4.4-.3.2-.5.6-.5 1.1 0 .3.1.5.2.7s.3.4.5.5c.2.2.4.3.7.4s.6.3.9.4c.6.2 1.1.4 1.6.7.5.2.9.5 1.2.8s.6.7.7 1.1c.2.4.2.9.2 1.5 0 1.1-.4 2-1.2 2.6s-2 .9-3.5.9c-.5 0-1 0-1.4-.1s-.8-.1-1.1-.2-.6-.2-.9-.3c-.2-.1-.4-.2-.6-.3l.7-1.8c.3.2.8.4 1.3.5.6.2 1.2.3 2 .3"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m65.5 51.3h2.3v2.3h-2.3z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 223.9 60.1",
    viewBox: "0 0 223.9 60.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "logo.svg";
export { ForwardRef as ReactComponent };